import { useQuery } from '@tanstack/react-query';
import type { DocumentAccessResponseDto } from '@monorepo/shared';
import { apiClient } from '../lib/axios';

const publicDocumentApi = {
  accessDocument: async (token: string): Promise<DocumentAccessResponseDto> => {
    const { data: response } = await apiClient.get<DocumentAccessResponseDto>(`/d/${token}`);
    return response;
  },
};

export const useAccessDocument = (token: string) => {
  return useQuery({
    queryKey: ['document-access', token],
    queryFn: () => publicDocumentApi.accessDocument(token),
    enabled: !!token,
    retry: false,
    staleTime: Infinity,
  });
};
